module.exports = __webpack_public_path__ + "static/img/casino-open-banner.c6c8c84.png";